import { formatDate } from '@btime/helpers'
import React, { useMemo } from 'react'

import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { TableHeadText } from '../../../../../components/pdf/TableHelpers'
import { getValidity } from '../../_helpers/pdfHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const SignatureSection = ({ serviceOrder }) => {
  const formattedDate = useMemo(() => {
    const date = getValidity(serviceOrder)

    return formatDate('DD [de] MMMM [de] YYYY', date)
  }, [serviceOrder])

  return (
    <View pageBreakAfter id="18">
      <Text bold size="small">
        18. ASSINATURA
      </Text>

      <Separator weight={4} />

      <Text align="right">{formattedDate}</Text>

      <Separator weight={8} />

      <Table width="75%" center>
        <TableRow>
          <TableHeadText colSpan={2} align="center">
            Responsável Revisão Técnica do Documento:
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableCol style={{ width: '50%' }}>
            <Text size="small">Engenheiro de Segurança do Trabalho</Text>
            <Text size="small">Rodrigo Ragazini</Text>
            <Text size="small">CREA: 5070254889</Text>
          </TableCol>
          <TableCol>
            <Text size="small">
              Este documento foi assinado com certificado digital (última página), emitido pela ICP-Brasil, através de
              chaves criptográficas.
            </Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={30} />
    </View>
  )
}

export default SignatureSection
